/* ==========================================================================
   What's New Badge
   Notification indicator that links to the changelog page
   ========================================================================== */

import { Link } from 'react-router-dom'
import { Sparkles } from 'lucide-react'
import { useChangelog } from '@/hooks/useChangelog'

/* --------------------------------------------------------------------------
   Inline variant (for provider header)
   -------------------------------------------------------------------------- */

export function WhatsNewLink() {
  const { hasNew } = useChangelog()

  if (!hasNew) return null

  return (
    <Link
      to="/changelog"
      className="flex items-center gap-1.5 text-sm text-[var(--color-deep-purple)] hover:text-[var(--color-deep-purple)]/80 transition-colors"
    >
      <span className="relative flex h-2 w-2">
        <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-[var(--color-deep-purple)] opacity-75" />
        <span className="relative inline-flex h-2 w-2 rounded-full bg-[var(--color-deep-purple)]" />
      </span>
      What's New
    </Link>
  )
}

/* --------------------------------------------------------------------------
   Sidebar variant (for admin layout)
   -------------------------------------------------------------------------- */

export function WhatsNewSidebarItem() {
  const { hasNew } = useChangelog()

  return (
    <a
      href="/changelog"
      target="_blank"
      rel="noopener noreferrer"
      className="flex items-center gap-3 px-3 py-2.5 rounded-md text-left w-full transition-colors focus:outline-none focus:ring-2 focus:ring-lavender text-charcoal hover:bg-gray-100"
    >
      <Sparkles className="h-5 w-5 flex-shrink-0 text-gray-500" aria-hidden="true" />
      <span className="text-sm">What's New</span>
      {hasNew && (
        <span className="ml-auto relative flex h-2.5 w-2.5">
          <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-[var(--color-deep-purple)] opacity-75" />
          <span className="relative inline-flex h-2.5 w-2.5 rounded-full bg-[var(--color-deep-purple)]" />
        </span>
      )}
    </a>
  )
}
